import { useState, useCallback, useMemo } from 'react';
const useEditor = ({ onEditorReady, onEditorChange, onFocus, onBlur, autoFocus } = {})=>{
    const [editorApi, setEditorApi] = useState(null);
    const handleEditorReady = useCallback((api)=>{
        setEditorApi(api);
        onEditorReady && onEditorReady(api);
    }, [
        onEditorReady
    ]);
    const handleEditorChange = useCallback((props)=>{
        onEditorChange && onEditorChange(props);
    }, [
        onEditorChange
    ]);
    const editorProps = useMemo(()=>({
            onReady: handleEditorReady,
            onChange: handleEditorChange,
            onFocus: onFocus,
            onBlur: onBlur,
            autoFocus
        }), [
        handleEditorReady,
        handleEditorChange,
        onFocus,
        onBlur,
        autoFocus
    ]);
    return {
        editorApi,
        editorProps
    };
};
export default useEditor;

//# sourceMappingURL=useEditor.js.map